import localConfig from 'mode-shared/configs/config';
import { QueryKeys } from 'mode-shared/constants/queryKeys';
import { contentfulClient } from 'mode-shared/utils';
import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { FormattedSuggestion, SuggestionsSkeleton } from '../types';

export interface PromptSuggestions {
  transactActions: FormattedSuggestion;
  synthTransactActions: FormattedSuggestion;
  chatWindow: FormattedSuggestion;
  dashboardWidget: FormattedSuggestion;
  synthChatWindow: FormattedSuggestion;
  modeChatWindow: FormattedSuggestion;
  tradeChatWindow: FormattedSuggestion;
}

const fetchSuggestions = async () => {
  try {
    let content = [];

    if (localConfig.showContentLive) {
      content = (
        await contentfulClient.getEntries<SuggestionsSkeleton>({
          content_type: 'suggestions',
          include: 10,
        })
      ).items;
    } else {
      content = (
        await axios.get<void, AxiosResponse<SuggestionsSkeleton[]>>(`${localConfig.contentfulUrl}/suggestions.json`)
      ).data;
    }

    const result: PromptSuggestions = {
      transactActions: { suggestions: [] },
      synthTransactActions: { suggestions: [] },
      chatWindow: { suggestions: [] },
      dashboardWidget: { suggestions: [] },
      synthChatWindow: { suggestions: [] },
      modeChatWindow: { suggestions: [] },
      tradeChatWindow: { suggestions: [] },
    };

    content.forEach((entry) => {
      const { name, suggestions } = entry.fields;

      const resultSuggestions = (suggestions || []).map((item) => ({
        label: item.fields.label,
        value: item.fields.value,
      }));

      switch (name) {
        case 'Transact Actions': // PromptGuidSuggestions
          result.transactActions.suggestions = resultSuggestions;
          break;
        case 'Synth transact action':
          result.synthTransactActions.suggestions = resultSuggestions;
          break;
        case 'Chat Window Suggestions': // ChatSuggestions
          result.chatWindow.suggestions = resultSuggestions;
          break;
        case 'Dashboard widget':
          result.dashboardWidget.suggestions = resultSuggestions;
          break;
        case 'Synth chat window suggestions':
          result.synthChatWindow.suggestions = resultSuggestions;
          break;
        case 'Mode Terminal Chat Window': // WelcomeScreenSuggestions
          result.modeChatWindow.suggestions = resultSuggestions;
          break;
        case 'Trade Chat Window Suggestions': // WelcomeScreenSuggestions
          result.tradeChatWindow.suggestions = resultSuggestions;
          break;
        default:
          break;
      }
    });

    return result;
  } catch (e) {
    console.error(e);
    return;
  }
};

export const useSuggestions = (options = {}) => {
  return useQuery({
    queryKey: [QueryKeys.AI_TERMINAL_SUGGESTIONS],
    queryFn: fetchSuggestions,
    ...options,
  });
};
